import CountryService from '../../shared/CountryService';
import { CustomerAgreementLanguage } from './types';

const agreementLanguageByCountryId: { [countryId: number]: string } = {
    [CountryService.mapCountryCodeToId('sv')]: 'sv',
    [CountryService.mapCountryCodeToId('fi')]: 'fi'
};

export function preferredAgreementLanguage(
    countryId: number,
    languages: CustomerAgreementLanguage[]
): string {
    const countryLanguage = agreementLanguageByCountryId[countryId];
    const offered = languages.find((language) => language.key === countryLanguage);

    if (offered) {
        return offered.key;
    }

    return languages.length > 0 ? languages[0].key : '';
}
